import React, { useEffect, useMemo } from "react";
import { CommunityFeedType, FeedLikeType } from "../../types";
import { useSelector } from "react-redux";

type ActivityReaderProps = {
  communityFeed: CommunityFeedType | undefined;
  onOpen?: () => void;
  feedLikes: FeedLikeType | undefined;
  createLikeLoading: boolean;
  deleteLikeLoading: boolean;
  showDetailedLikes: boolean;
  setShowDetailedLikes: React.Dispatch<React.SetStateAction<boolean>>;
};

const ActivityReader: React.FC<ActivityReaderProps> = ({
  communityFeed,
  feedLikes,
  onOpen,
  deleteLikeLoading,
  createLikeLoading,
  setShowDetailedLikes,
  showDetailedLikes,
}) => {
  const user = useSelector((state: any) => state.user.userDetails);

  const specificUserLike = communityFeed?.feedLikes?.find(
    (a) => a.likedBy.id === user.id
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowDetailedLikes(true);
    }, 600000); // 10 minutes

    return () => clearTimeout(timer); // Clean up the timer when the component unmounts
  }, [setShowDetailedLikes]);

  const likes = useMemo(() => {
    return communityFeed?.feedLikes
      ?.slice(0, 2)
      .map((a) => {
        const fullName = `${a.likedBy.firstName} ${a.likedBy.lastName}`;
        return a === specificUserLike ? " You " : fullName;
      })
      .join(" and ");
  }, [communityFeed?.feedLikes, specificUserLike]);

  const totalLikes = communityFeed?.feedLikes?.length || 0;

  // const displayLikes = totalLikes > 1
  // ? `${totalLikes - 1} likes`
  // : totalLikes === 1 && action === "delete"
  // ? "" // Don't display "0 likes" if removing the last like
  // : `${totalLikes} like${totalLikes > 1 ? "s" : ""}`;

  return (
    <div className="w-full flex justify-between text-[#646464] font-Poppins text-[8px] absolute h-5 lg:bottom-[60px] bottom-[50px] mx-auto lg:text-[14.7px] lg:font-SegoeUI font-normal px-4">
      <div className="flex text-searchCol w-[64%]">
        {createLikeLoading || deleteLikeLoading ? (
          <div className="flex">
            <p>
              {deleteLikeLoading
                ? totalLikes > 1
                  ? `${totalLikes - 1} like${totalLikes > 1 ? "s" : ""} `
                  : totalLikes === 0 && ""
                : createLikeLoading &&
                  `${totalLikes + 1} like${totalLikes > 1 ? "s" : ""}`}
            </p>
          </div>
        ) : (
          communityFeed?.id &&
          communityFeed &&
          communityFeed?.feedLikes?.length > 0 && (
            <div className="flex">
              {showDetailedLikes ? (
                communityFeed && communityFeed?.feedLikes?.length < 3 ? (
                  <p>Liked by {likes}</p>
                ) : (
                  <p>
                    {specificUserLike
                      ? `You and ${totalLikes - 1} others`
                      : `${totalLikes} like${totalLikes > 1 ? "s" : ""}`}
                  </p>
                )
              ) : (
                <p>{`${totalLikes} like${totalLikes > 1 ? "s" : ""}`}</p>
              )}
            </div>
          )
        )}
      </div>
      <div className="flex gap-1 w-[35%] justify-end text-searchCol">
        {communityFeed?.comments?.length ? (
          <div className="flex gap-1">
            <div className="flex cursor-pointer" onClick={onOpen}>
              {communityFeed.comments.length === 1
                ? "View comment"
                : `View all ${communityFeed.comments.length} comments`}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ActivityReader;
